import { render } from "./DeleteOrAddFormItemsDynamically.vue?vue&type=template&id=5bcd946a"
import script from "./DeleteOrAddFormItemsDynamically.vue?vue&type=script&lang=js"
export * from "./DeleteOrAddFormItemsDynamically.vue?vue&type=script&lang=js"
script.render = render

export default script